import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './AppIcon';

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigationSections = [
    {
      title: 'Main',
      items: [
        {
          label: 'Portfolio',
          path: '/agency-dashboard-portfolio-overview',
          icon: 'LayoutDashboard',
        },
        {
          label: 'Analysis',
          path: '/client-roi-calculator-analysis-engine',
          icon: 'Calculator',
        },
      ],
    },
    {
      title: 'Configuration',
      items: [
        {
          label: 'Platform Configuration',
          path: '/platform-configuration-cost-management',
          icon: 'Settings',
        },
        {
          label: 'Marketing Services',
          path: '/marketing-services-pricing-matrix',
          icon: 'Package',
        },
      ],
    },
    {
      title: 'Insights',
      items: [
        {
          label: 'Financial Dashboard',
          path: '/financial-analysis-profitability-dashboard',
          icon: 'TrendingUp',
        },
        {
          label: 'Budget Optimization',
          path: '/budget-optimization-recommendation-engine',
          icon: 'Target',
        },
      ],
    },
  ];

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button
        className="mobile-menu-button"
        onClick={handleToggle}
        aria-label="Toggle mobile menu"
        aria-expanded={isOpen}
      >
        <Icon name={isOpen ? 'X' : 'Menu'} size={20} />
      </button>
      {isOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={handleClose}
          aria-hidden="true"
        />
      )}
      <aside className={`mobile-menu-panel ${isOpen ? '' : 'closed'}`}>
        <div className="mobile-menu-header">
          <div className="flex items-center gap-3">
            <div className="header-logo">
              <Icon name="Calculator" size={20} />
            </div>
            <span className="text-base font-semibold text-foreground">
              ROI Calculator Pro
            </span>
          </div>
          <button
            className="mobile-menu-close"
            onClick={handleClose}
            aria-label="Close menu"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <nav className="mobile-menu-nav">
          {navigationSections?.map((section) => (
            <div key={section?.title} className="mobile-menu-section">
              <h3 className="mobile-menu-section-title">{section?.title}</h3>
              <ul>
                {section?.items?.map((item) => (
                  <li key={item?.path}>
                    <NavLink
                      to={item?.path}
                      className={({ isActive }) =>
                        `mobile-menu-item ${isActive ? 'active' : ''}`
                      }
                      onClick={handleClose}
                    >
                      <Icon name={item?.icon} size={18} />
                      <span>{item?.label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default MobileMenu;